// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"0353f537","168":"6eb92ff3","284":"46f8348d","579":"5ed64a33","601":"8e066a8e","626":"75e5dcfd","945":"53697312"}[chunkId] + ".chunk.js";
};